import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { Contextone } from './Context';
import { fetchGetPages } from "./Api";
import Cookies from 'js-cookie';


const Support = () => {
  const location = useLocation();
  const history = useHistory();
  const {page_name} = useParams();

  const [pages, setPages] = useState([]);
  const [currentUrl, setCurrentUrl] = useState(""); 

  const counterContext = useContext(Contextone);
  const url = counterContext.isDomain;
  const apiUrl = `https://${url}`;
  const prevLoc = Cookies.get('loc');
  

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const data = await fetchGetPages(apiUrl);
        setPages(data.result);
      } catch (error) {
        console.error("Error fetching pages:", error);
      }
    };
    fetchPages();
  }, []);

  useEffect(() => {
    if (page_name && pages.length > 0) {
      const matchedPage = pages.find(page => page.page_name.replace(/\s+/g, '') === page_name);
      if (matchedPage) {
        {url === 'admin.aaryaadigital.com' ? setCurrentUrl(`${matchedPage.url}`):
        setCurrentUrl(`${apiUrl}${matchedPage.url}`)}
      }
    }
  }, [page_name, pages]);

  const handleTabClick = (pageName) => {
    history.push(`/Support/${pageName.replace(/\s+/g, '')}`);
  };

  return (
    <div className="support_main">
      
      <div className="sideBar support_sideBar">
        <div className="support_sideBarLeft__jelTh">
          <a className="support_back_home__XuJMg" onClick={() => history.push('/')}>
            <img src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/help-back-arrow.svg" alt="back" />
            Back to home
          </a>
          <h1>Help &amp; Support</h1>
        </div>
        <div className="MuiTabs-root MuiTabs-vertical css-9o6jyu">
          <div className="MuiTabs-scroller MuiTabs-hideScrollbar MuiTabs-scrollableY css-ccrt04">
            <div aria-orientation="vertical" className="MuiTabs-flexContainer MuiTabs-flexContainerVertical css-j7qwjs" role="tablist">
              {pages.map((mtype) => (
                <button
                  key={mtype.id}
                  className={`MuiButtonBase-root MuiTab-root MuiTab-textColorPrimary tabs_btn support css-1q2h7u5 ${page_name === mtype.page_name.replace(/\s+/g, '') ? "Mui-selected" : ""}`}
                  onClick={() => handleTabClick(mtype.page_name.replace(/\s+/g, ''))} 
                  style={{
                    backgroundColor: page_name === mtype.page_name.replace(/\s+/g, '') ? "red" : "",
                    color: page_name === mtype.page_name.replace(/\s+/g, '') ? "white" : "",
                  }}
                >
                  <h2 style={{ fontSize: "0.875rem", fontWeight: "normal" }}>{mtype.page_name}</h2>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="support_content__CPMre">
        <div className="support_topNav__UMejo">
          <h1>
            <img src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/help-back-arrow.svg" alt="" />
            {page_name || "Help & Support"}
          </h1>
        </div>
        <div id="staticPage" className="support_staticPage__d7J3_">
          {currentUrl ? (
            <iframe id="support" src={currentUrl} width="100%" height="100%"></iframe>
          ) : (
            <p style={{ color: "white", textAlign: "center" }}>Select a page from the left.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Support;